import formatNumber from "@casino/legacy/client/shared/Timer/TimerView/Box/Field/helpers/formatNumber";
import useTimer from "@casino/legacy/client/shared/Timer/useTimer";
import { useEffect, useState } from "react";
import useResendingEnableTimeCookie from "./useResendingEnableTimeCookie";

const getTimeLeft = (resendingEnableTimeCookie: number) => {
  const timePassed = (resendingEnableTimeCookie - new Date().getTime()) / 1000;
  return timePassed > 0 ? timePassed : 0;
};

const useResendCodeTimer = (onResendCodeClick: () => void) => {
  const { resendingEnableTimeCookie, setResendingEnableTimeCookie } =
    useResendingEnableTimeCookie();

  const [secondsLeft, setSecondsLeft] = useState(
    getTimeLeft(resendingEnableTimeCookie),
  );

  const timeLeft = useTimer({ format: "mm:ss", secondsLeft });

  const handleInitializeTimer = () => {
    setSecondsLeft(0);
    setResendingEnableTimeCookie();
  };

  const handleResendClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.preventDefault();
    onResendCodeClick();
    setSecondsLeft(0);
    setResendingEnableTimeCookie();
  };
  const isTimeOver = timeLeft.minutes + timeLeft.seconds === 0;

  useEffect(() => {
    if (!isTimeOver) {
      return;
    }
    setSecondsLeft(getTimeLeft(resendingEnableTimeCookie));
  }, [setSecondsLeft, resendingEnableTimeCookie]);

  const timeLeftFormatted = `${formatNumber(timeLeft.minutes)}:${formatNumber(
    timeLeft.seconds,
  )}`;

  return {
    handleResendClick,
    handleInitializeTimer,
    timeLeftFormatted,
    isTimeOver,
  };
};

export default useResendCodeTimer;
